import { useSelector,useDispatch } from 'react-redux';
import { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { visualizerActions } from '../../store';
import { SERIES_IDS } from '../../Helpers/SeriesHelper';
import TopMenu from '../TopMenu/TopMenu';
import Visualizer from '../Visualizer/Visualizer';
import ProductMenu from '../ProductMenu/ProductMenu';
import ShareModal from '../ShareModal/ShareModal';
import EmailShareModal from '../EmailShareModal/EmailShareModal';
import ProjectsModal from '../ProjectsModal/ProjectsModal';
import HelpModal from '../HelpModal/HelpModal';
import FeedbackModal from '../FeedbackModal/FeedbackModal';
import ZoomModal from '../ZoomModal/ZoomModal';
import styles from './VisualizerPage.module.css';
import useCompare from '../Compare/useCompare'; 

export default function VisualizerPage() {
    const dispatch = useDispatch();
    const { specifier, selString } = useParams();
    const [searchParams] = useSearchParams();
    const submenuParam = searchParams.get("submenu");
    //flooringSeriesIds
    const shareModalStatus = useSelector(state => state.ui.shareModalActive);
    const emailModalStatus = useSelector(state => state.ui.emailModalActive);
    const projectsModalStatus = useSelector(state => state.ui.projectsModalActive);
    const helpModalStatus = useSelector(state => state.ui.helpModalActive);
    const feedbackModalStatus = useSelector(state => state.ui.feedbackModalActive);
    const zoomModalStatus = useSelector(state => state.ui.zoomModalActive);
    const FLOORING_SERIES_MAP = {
        'modular carpet': [SERIES_IDS.carpet],
        'lvt': [SERIES_IDS.lvt],
        'resilient sheet': [SERIES_IDS.heterogeneous, SERIES_IDS.homogeneous]
    };

    useEffect(() => {
        if (!submenuParam) return;

        const key = submenuParam.trim().toLowerCase();
        const seriesIds = FLOORING_SERIES_MAP[key];

        if (!seriesIds) return;

        dispatch(visualizerActions.setActiveFlooringSubMenuTab(key));
        dispatch(visualizerActions.setActiveFlooringSeriesIds(seriesIds));
    }, [submenuParam, dispatch]);

    const {
        containerRef,
        afterWrapperRef,
        sliderRef,
        setIsDragging,
        handleCompareToggle,
        handleCompareSideChange,
        applyCompareSide
    } = useCompare();

    return (
        <>
            <TopMenu extended page="visualizer" />
            <section className={styles.visualizerView}>
                <div className={styles.visualizerContainer}>
                    <Visualizer
                        handleCompareToggle={handleCompareToggle}
                        applyCompareSide={applyCompareSide}
                        handleCompareSideChange={handleCompareSideChange}
                        containerRef={containerRef}
                        afterWrapperRef={afterWrapperRef}
                        sliderRef={sliderRef}
                        setIsDragging={setIsDragging}
                    />
                </div>
                <div className={styles.productMenuContainer}>
                    <ProductMenu/>
                </div>
            </section>

            {shareModalStatus && <ShareModal />}
            {emailModalStatus && <EmailShareModal />}
            {projectsModalStatus && <ProjectsModal />}
            {helpModalStatus && <HelpModal />}
            {feedbackModalStatus && <FeedbackModal />}
            {zoomModalStatus && <ZoomModal />}
        </>
    );
}
